import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { AppActions } from 'src/store/AppReducer';
import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';
import { DefineLeavesInformation } from 'src/models/leave';
import { getAllLeaveTypeNames, updateDefineLeaves } from 'src/services/DefineLeaveService';
import { getAllGenders } from 'src/services/employeeService';
import { LeaveType } from './enum/DefineLeaves';

const EditDefineLeaves = ({ toggle, open, getData, data }) => {
  const dispatch = useDispatch();
  const TextFieldStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const CheckboxLabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px',
    color: '#ffffff'
  }

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '13px'
  };

  const { register, handleSubmit, reset, getValues } = useForm<DefineLeavesInformation>();

  const [ employmentTypeError, setEmploymentTypeError ] = useState('');
  const [ typeNameError, setTypeNameError ] = useState('');
  const [ genderError, setGenderError ] = useState('');
  const [ noOfDaysError, setNoOfDaysError ] = useState('');
  const [ renewPeriodError, setRenewPeriodError ] = useState('');
  const [ hrApprovalError, setHrApprovalError ] = useState('');

  const [ employmentType, setEmploymentType ] = useState('');
  const [ leaveType, setLeaveType ] = useState('');
  const [ gender, setGender ] = useState('');
  const [ noOfDays, setNoOfDays] = useState('');
  const [ renewPeriod, setRenewPeriod ] = useState('');
  const [ hrApproved, setHrApproved ] = useState(false);

  const [ employeeTypeList, setEmployeeTypeList ] = useState(['PERMANENT', 'PROBATION', 'INTERN']);
  const [ renewPeriodList, setRenewPeriodList ] = useState(['ANNUALLY', 'MONTHLY', 'N/A']);


  const [ genderList, setGenderist ] = useState([]);
  
  const getAllGenderDetails = () => {
    getAllGenders().then((res) => {
      setGenderist(res?.data);
    });
  };

  useEffect(() => {
    getAllGenderDetails();
  }, []);

  const [ leaveTypeNameList, setLeaveTypeNameList ] = useState([]); 

  const getAllLeaveTypeNameDetails = () => {
    getAllLeaveTypeNames().then((res) => {
      setLeaveTypeNameList(res.data.data);
    });
  };

  useEffect(() => {
    getAllLeaveTypeNameDetails();
  }, []);

  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [defineLeaveObj, setDefineLeaveObj] = useState<any>({
    id: data.id,
    employmentType: data.employmentType,
    typeName: data.typeName,
    gender: data.gender,
    noOfDays: parseFloat(data.noOfDays),
    renewPeriod: data.renewPeriod,
    hrApproved: data.hrApproved
  });

  const toggleConfirmation = () => {
    if (openConfirmation) {
      setOpenConfirmation(false);
    }
    if (
      defineLeaveObj.hrApproved !== ''  &&
      employmentType  &&
      defineLeaveObj.typeName &&
      gender &&
      renewPeriod 
    ) {
      setEmploymentTypeError('');
      setTypeNameError('');
      setGenderError('');
      setRenewPeriodError('');
      setHrApprovalError('');

      if(
        (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) || 
        (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) || 
        (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME) ||
        (defineLeaveObj.typeName === LeaveType.CARRY_FORWARD_LEAVE)
      ) {
        setNoOfDaysError('');
        setOpenConfirmation(!openConfirmation);
      }else{
        if(defineLeaveObj.noOfDays !== '' && parseFloat(defineLeaveObj.noOfDays) > 0.0) {
          setNoOfDaysError('');
          setOpenConfirmation(!openConfirmation);
        }
      }

    } else if (!employmentType) {
        setEmploymentTypeError('Employee Type is required.');
    } else if (!defineLeaveObj.typeName) {
        setTypeNameError('Leave Type is required.');
    } else if (!gender) {
        setGenderError('Gender is required.');
    } 
    else if (!renewPeriod) {
        setRenewPeriodError('Renew Period is required.');
    }
    else if(
      (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) || 
      (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) || 
      (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME) ||
      (defineLeaveObj.typeName === LeaveType.CARRY_FORWARD_LEAVE)
    ) {
      setNoOfDaysError('');
    }else{
     if (defineLeaveObj.noOfDays === '') {
      setNoOfDaysError('Leave No Days is required.');
    } else if (parseFloat(defineLeaveObj.noOfDays) < 0.0) {
      setNoOfDaysError('Leave No Days cannot be only 0.');
    }}
  };

  useEffect(() => {
    setDefineLeaveObj({
      id: data.id,
      employmentType: data.employmentType,
      typeName: data.typeName,
      gender: data.gender,
      noOfDays: data.noOfDays,
      renewPeriod: data?.renewPeriod === 'NA' ? 'N/A' : data.renewPeriod,
      hrApproved: data.hrApproved
    });  
      setEmploymentType(data.employmentType);
      setLeaveType(data.typeName);
      setGender(data.gender)
      setNoOfDays(data.noOfDays);
      setRenewPeriod(data.renewPeriod);
      setHrApproved(data.hrApproved);
  }, [data]);

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmit = () => {

    if(
      defineLeaveObj.employmentType  &&
      defineLeaveObj.typeName &&
      defineLeaveObj.gender &&
      defineLeaveObj.renewPeriod 
    ) {
      dispatch(AppActions.showLoader());

      setEmploymentTypeError('');
      setTypeNameError('');
      setGenderError('');
      setRenewPeriodError('');
      setHrApprovalError('');

      if(
        (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) 
        || (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) 
        || (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME)
      ) {
        setNoOfDaysError('');
      }else{
        if(defineLeaveObj.noOfDays !== '' && parseFloat(defineLeaveObj.noOfDays) > 0.0) {
          setNoOfDaysError('');
        }
      }

      const body = {
        id: defineLeaveObj.id,
        employmentType: defineLeaveObj.employmentType,
        typeName: defineLeaveObj.typeName,
        gender: defineLeaveObj.gender,
        noOfDays: defineLeaveObj.noOfDays,
        renewPeriod: defineLeaveObj?.renewPeriod === 'N/A' ? 'NA' : defineLeaveObj.renewPeriod,
        hrApproved: defineLeaveObj.hrApproved,
        description: "null",
        status: null
      }

      updateDefineLeaves(body)
        .then(() => {
          reset();
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Your leave type details have been updated.',
              severity: 'success'
            })
          );
          getData();
          toggle();
          toggleConfirmation();
          dispatch(AppActions.hideLoader());
        })
        .catch((error) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: error.response.data.message,
              severity: 'error'
            })
          );
          toggleConfirmation();
          dispatch(AppActions.hideLoader());
        });
    } if (!employmentType) {
        setEmploymentTypeError('Employee Type is required.');
    } if (!defineLeaveObj.typeName) {
        setTypeNameError('Leave Type is required.');
    } if (!gender) {
        setGenderError('Gender is required.');
    }
     if (!renewPeriod) {
        setRenewPeriodError('Renew Period is required.');
    }
    if(
      (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) 
      || (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) 
      || (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME)
    ) {
      setNoOfDaysError('');
    }else{
     if (defineLeaveObj.noOfDays === '') {
      setNoOfDaysError('Leave No Days is required.');
    } else if (parseFloat(defineLeaveObj.noOfDays) < 0.0) {
      setNoOfDaysError('Leave No Days cannot be only 0.');
    }}
  };

  const [selectedOption, setSelectedOption] = useState('');  

  const onClose = () => {
    setEmploymentTypeError('');
    setTypeNameError('');
    setGenderError('');
    setNoOfDaysError('');
    setRenewPeriodError('');
    setHrApprovalError('');

    setDefineLeaveObj({
      id: data.id,
      employmentType: data.employmentType,
      typeName: data.typeName,
      gender: data.gender,
      noOfDays: data.noOfDays,
      renewPeriod: data?.renewPeriod === 'NA' ? 'N/A' : data.renewPeriod,
      hrApproved: data.hrApproved
    });

    toggle();
  };

  const leaveTypeHandler = (selectLeaveType: string) => {
    setDefineLeaveObj((prev) => ({
      ...prev,
      typeName: selectLeaveType
    }));

    if(selectLeaveType === LeaveType.LIEU_LEAVE) {
      setDefineLeaveObj((prev) => ({
        ...prev,
        noOfDays: '',
        renewPeriod: 'N/A'
      }));
    }else if (selectLeaveType === LeaveType.CARRY_FORWARD_LEAVE) {
      setDefineLeaveObj((prev) => ({
        ...prev,
        noOfDays: 0,
        gender: 'ALL'
      }));
    }else if (selectLeaveType === LeaveType.SHORT_LEAVE) {
      setDefineLeaveObj((prev) => ({
        ...prev,
        noOfDays: 2,
        renewPeriod: 'MONTHLY'
      }));
    }else if ((selectLeaveType === LeaveType.NO_PAY_LEAVE) || (selectLeaveType === LeaveType.WORK_FROM_HOME)) {
      setDefineLeaveObj((prev) => ({
        ...prev,
        noOfDays: 0,
        renewPeriod: 'N/A'
      }));
    }
     else {
      setDefineLeaveObj((prev) => ({
        ...prev,
        noOfDays: '',
        renewPeriod: ''
      }));
    }
  }

  return (
    <Fragment>
      {' '}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 2 }}>
          <Typography style={{ fontSize: '15px' }} variant="h3">
            Edit Leave
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Employment Type<span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              MenuProps={{ autoFocus: false }}
              labelId="search-select-label"
              {...register('employmentType', {})}
              style={{
                height: '2.25rem',
                width: '94%',
                marginLeft: 15,
                marginTop: 5,
                paddingRight: 15,
                fontSize: '13px'
              }}
              id="search-select"
              displayEmpty
              value={defineLeaveObj.employmentType}
              onChange={(e) => {
                setDefineLeaveObj((prev) => ({
                  ...prev,
                  employmentType: e.target.value
                }));
              }}
            >
              <MenuItem style={{ display: 'none' }} selected disabled value={''}>
                Select Employment Type
              </MenuItem>
              {employeeTypeList.length > 0 &&
                employeeTypeList?.map((option, i) => (
                  <MenuItem key={i} value={option}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {employmentTypeError}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Leave Type <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              className="select-text"
              size="small"
              style={selectStyle}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              {...register('typeName', {})}
              defaultValue={''}
              value={defineLeaveObj.typeName}
              onChange={(e) => {
                leaveTypeHandler(e.target.value);
              }}
            >
              <MenuItem style={{ display: 'none' }} selected disabled value={''}>
                Select Leave Type
              </MenuItem>
              {leaveTypeNameList.length > 0 &&
                leaveTypeNameList?.map((option, i) => {
                return <MenuItem value={option.name}>{option.name}</MenuItem>
              })}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {typeNameError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Gender <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              disabled={(defineLeaveObj.typeName === LeaveType.CARRY_FORWARD_LEAVE)}
              className="select-text"
              size="small"
              style={selectStyle}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              {...register('gender', {})}
              defaultValue={''}
              value={defineLeaveObj.gender}
              onChange={(e) => {
                setDefineLeaveObj((prev) => ({
                  ...prev,
                  gender: e.target.value.toUpperCase()
                }));
              }}
            >
              <MenuItem style={{ display: 'none' }} selected disabled value={''}>
                Select Gender
              </MenuItem>
              {genderList.length > 0 &&
                genderList?.map((option, i) => {
                return <MenuItem value={option.name.toUpperCase()}>{option.name.toUpperCase()}</MenuItem>
              })}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {genderError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Leave No of Days
              {(
                (leaveType !== LeaveType.LIEU_LEAVE) && 
                (leaveType !== LeaveType.NO_PAY_LEAVE) && 
                (leaveType !== LeaveType.WORK_FROM_HOME) && 
                (leaveType !== LeaveType.CARRY_FORWARD_LEAVE)) 
              && (<span style={{ color: 'red' }}>*</span>)}
            </Typography>
            <input
              disabled={
                (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.SHORT_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME) ||
                (defineLeaveObj.typeName === LeaveType.CARRY_FORWARD_LEAVE)
              }
              maxLength={30}
              {...register('noOfDays', {
                setValueAs: element => element.trim(),
              })}
              style={{
                marginTop: 4,
                marginLeft: 15,
                width: '27.7rem',
                fontSize: '13px',
                backgroundColor: 
                (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.SHORT_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME) ||
                (defineLeaveObj.typeName === LeaveType.CARRY_FORWARD_LEAVE)
                ? '#C0C0C0' : '',
                borderRadius: '4px 4px',
                height: '2.3rem',
                borderStyle: 'solid',
                borderWidth: '1px',
                paddingLeft: '0.8rem'
              }}
              placeholder="Enter No of Days"
              value={
                (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME) ||
                (defineLeaveObj.typeName === LeaveType.CARRY_FORWARD_LEAVE)
                ? '---' : defineLeaveObj.noOfDays}
              onChange={(e) => {
                if (e.target.value.length > 50) {
                  setNoOfDaysError('Leave No Days must not exceed 50 characters');
                } else if(parseFloat(e.target.value) <= 0.0) {
                  setNoOfDaysError('Leave No Days cannot be only 0.');
                } else {
                  setNoOfDaysError('');
                }
                setDefineLeaveObj((prev) => ({
                  ...prev,
                  noOfDays: e.target.value.trim()
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {noOfDaysError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Renew Period<span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              MenuProps={{ autoFocus: false }}
              labelId="search-select-label"
              {...register('renewPeriod', {})}
              style={{
                height: '2.25rem',
                width: '94%',
                marginLeft: 15,
                marginTop: 5,
                paddingRight: 15,
                fontSize: '13px'
              }}
              id="search-select"
              displayEmpty
              defaultValue=""
              disabled={
                (defineLeaveObj.typeName === LeaveType.SHORT_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.NO_PAY_LEAVE) || 
                (defineLeaveObj.typeName === LeaveType.WORK_FROM_HOME) || 
                (defineLeaveObj.typeName === LeaveType.LIEU_LEAVE)
              }
              value={defineLeaveObj.renewPeriod}
              onChange={(e) => {
                setDefineLeaveObj((prev) => ({
                  ...prev,
                  renewPeriod: e.target.value
                }));
              }}
            >
              <MenuItem style={{ display: 'none' }} selected disabled value={''}>
                Select Renew Period
              </MenuItem>
              {renewPeriodList.length > 0 &&
                renewPeriodList?.map((option, i) => (
                  <MenuItem key={i} value={option}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {renewPeriodError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={CheckboxLabelStyle} fontWeight="light" variant="h5">
              HR Approval
            </Typography>
            <FormControlLabel
              style={TextFieldStyle}
              control={<Checkbox {...register('hrApproved')} checked={defineLeaveObj.hrApproved} 
              onChange={(e) => {
                setDefineLeaveObj((prev) => ({
                  ...prev,
                  hrApproved: e.target.checked
                }));
              }} 
              />}
              id="create-account"
              label={
                <Typography style={{ fontSize: '12px' }}>
                  HR Approval
                </Typography>
              }
            />
          </Grid>
          <Grid
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
            xs={12}
          >
            <Button
              sx={{
                width: '10%',
                fontWeight: 'normal',
                background: '#F5F7FF',
                fontSize: '13px'
              }}
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={isLoading}
              className={isLoading ? 'loading' : ''}
              sx={{
                ml: 2,
                width: '10%',
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#0069E4'
              }}
              variant="contained"
              type="button"
              onClick={toggleConfirmation}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure you want to update this leave type?`}
        onConfirm={() => onSubmit()}
        noToggle={toggleConfirmation}
      />
    </Fragment>
  );
};

export default EditDefineLeaves;
